import { z } from 'zod';
import { revenueBrandSchema } from '../revenueBrand.js';
import { subscriptionBillingCadenceSchema } from './subscriptionBillingCadence.js';
import { subscriptionDocumentInputSchema } from './subscriptionDocument.js';
import { subscriptionInfoFields } from './subscriptionInfo.js';
import { subscriptionPaymentMethodSchema } from './subscriptionPaymentMethod.js';
export const MAXIMUM_FREE_DAYS = 365;
export const subscriptionConfigurationSchema = z.object({
    ...subscriptionInfoFields,
    planId: z.number().int().positive(),
    paymentMethod: subscriptionPaymentMethodSchema,
    billingCadence: subscriptionBillingCadenceSchema,
    revenueBrand: revenueBrandSchema,
    // Optional because Sales might not have any documents to link and would rely on the ToS to be accepted.
    // Absent keep the previous documents.
    documents: subscriptionDocumentInputSchema.array().optional(),
    initialFreeDays: z.int().min(0).max(MAXIMUM_FREE_DAYS).optional(),
});
